import { IUserProfile, UserProfile } from '@/models/dexie/UserProfile';
import DexieDB from './DexieDB';
import DexieDBProvider from './DexieDBProvider';
import { AuthentificationService } from './index';
import { LoggerService } from '@/utils';

class UserProfileProvider {
    private dexieDB: DexieDB = DexieDBProvider.getInstance().dexieDB;

    // tslint:disable-next-line: no-empty
    constructor() {
    }

    /**
     * Put/Update an user profile
     * @param inUserProfile DexieDataSetEvent
     */
    public async PutUserProfile(inUserProfile: UserProfile): Promise<number> {
        return this.dexieDB.put<UserProfile>(this.dexieDB!.getTables().userProfiles, inUserProfile);
    }

    public async FetchUserProfile(inUserId: string): Promise<IUserProfile> {
        const tableStrings = this.dexieDB.getTables();
        const userProfileTable = this.dexieDB.getTable<IUserProfile>(tableStrings.userProfiles);
        const userProfile = (await userProfileTable.toArray()).find((user: IUserProfile) => user.userId === inUserId);

        const result: Promise<IUserProfile> = new Promise<IUserProfile>(async (resolve, reject) => {
            if (userProfile !== undefined) {
                resolve(userProfile);
            } else {
                // if user is not in dexidb, create a new one
                await AuthentificationService.GetUser()
                    .then(async (user) => {
                        if (user != null && user.profile.sub !== undefined) {
                            const newUserProfile = new UserProfile({
                                userId: user.profile.sub,
                                userName: user.profile.name,
                                userEmail: user.profile.email,
                                units: [],
                            });
                            await this.dexieDB.put<IUserProfile>(tableStrings.userProfiles, newUserProfile)
                                .then((userProfileId) => {
                                    newUserProfile.id = userProfileId;
                                    resolve(newUserProfile);
                                }).catch((error) => {
                                    LoggerService.LogError(`Error on saving new user profile: `, error);
                                });
                        } else {
                            LoggerService.LogError(`Error on fetching user. AuthentificationService returned an emtpy user`);
                        }
                    }).catch((error) => {
                        LoggerService.LogError(`Error on fetch user to save profile: `, error);
                    });
            }
        });
        return result;
    }
}

export default UserProfileProvider;
